<template>
  <div class="clients">
    <div class="title row column-s">
      <div class="grid-12-s text-center-s" :class="showForm ? 'grid-12' : 'grid-8-m grid-9-g'">
        <i class="fa fa-users"></i>&nbsp; CLIENTES
        <Button :layout="showForm ? 'red-go' : 'green-go'" title="NOVO CLIENTE" @click="showForm = !showForm">{{
          showForm ? "x" : "+" }}</Button>
        <div v-if="showForm" class="new">
          <ClientForm :reload="load" />
        </div>
      </div>
      <div v-if="!showForm" class="grid-3-g grid-4-m grid-12-s">
        <div class="search fa">
          <input type="text" placeholder="Buscar" v-model="search" />
        </div>
      </div>
    </div>
    <ul v-if="!loader" class="column list">
      <div class="row label">
        <div class="grid-1">ID</div>
        <div class="grid">NOME</div>
        <div class="grid hide-s">TIPO</div>
        <div class="grid hide-s">CNPJ</div>
        <div class="grid">CIDADE</div>
        <div class="grid">ENGAJAMENTO</div>
        <div class="grid-1 text-center">STATUS</div>
      </div>
      <li v-for="(client, i) of filteredClients" :key="'client' + i" class="column">
        <div class="row line" @click="toggleClient(filteredClients[i])">
          <div class="grid-1 id">
            <b>{{ client.id }}</b>
          </div>
          <div class="grid">{{ client.nome_fantasia || client.nome }}</div>
          <div class="grid hide-s" style="text-transform: capitalize;">{{ client.tipo_pessoa }}</div>
          <div class="grid hide-s">{{ client.cnpj | cnpj }}</div>
          <div class="grid">{{ client.cidade }}/{{ client.estado }}</div>
          <div class="grid">{{ client.engajamento }}</div>
          <div class="row justify-around grid-1">
            <div v-if="client.status !== 'ativo'" title="CLIENTE INATIVO" class="status red">
              <i class="fa fa-exclamation"></i>
            </div>
            <div v-if="client.cadastro_agregado" title="POSSUI AGREGADOS" class="status green">
              a<i class="fa fa-plus font-10"></i>
            </div>
          </div>
        </div>
        <div v-if="client.show">
          <ClientForm :client="client" :reload="load" />

          <div class="column aggregate" v-if="client.cadastro_agregado">
            <h3>Agregados</h3>
            <div class="row">
              <Button class="aggregate-new-button" layout="white-green" @click="showAggregate(filteredClients[i])"
                v-if="client.aggregate && !client.aggregate.show">
                <i class="fa fa-plus"></i> AGREGADO
              </Button>
              <Button v-if="client.aggregate && client.aggregate.show" class="aggregate-new-button" layout="red-s"
                @click="showAggregate(filteredClients[i])">
                <i class="fa fa-times"></i> FECHAR
              </Button>
            </div>
            <form v-if="client.aggregate && client.aggregate.show" class="aggregate-new-form column"
              onsubmit="return false;" @submit="newAggregate(client)">
              <div class="row column-s">
                <input v-model="client.aggregate.nome" type="text" class="input" placeholder="Nome" required />
                <input v-model="client.aggregate.celular" @input="mask(filteredClients[i])" type="text" class="input"
                  placeholder="Celular" required />
                <input v-model="client.aggregate.email" type="email" class="input" placeholder="E-mail" required />
                <Button class="new-aggregate-button" layout="green-go">
                  <i class="fa fa-plus"></i> ADICIONAR
                </Button>
              </div>
              <div class="aggregate-import row column-s" @drop.prevent="drop" @dragover.prevent>
                <div class="grid-6 grid-12-s text">
                  O arquivo, deverá estar no formato
                  <b>.csv</b> com os seguintes campos separados por ponto e vírgula:
                  <b>email; nome; celular</b>
                  <br />
                  <p>
                    - O nome deve ser completo com pelo menos duas palavras.
                    <br />- O email deve conter domínio válido. <br />- O celular deverá
                    ter obrigatoriamente 11 dígitos (código operadora + número do
                    celular).
                  </p>
                  <a href="/templates/template-cliente.csv" target="_blank">
                    <Button class="download-template" layout="white-s" type="button"><i class="fa fa-download"></i>
                      Download Template</Button>
                  </a>
                  <br />
                </div>
                <div class="grid-6 grid-12-s column align-center justify-center import-area">
                  <Button layout="blue-m" type="button" @click="setID(filteredClients[i], i)"
                    :loader="client.loader || false">
                    <i class="fa fa-upload"></i> IMPORTAR
                  </Button>
                  <input :id="'attach' + client.id" type="file" ref="files" @change="loadFile" class="hide" />
                  <div class="field">
                    <div class="filler row align-center" :style="`width: ${file.percentLoaded}%`">
                      {{ file.name || file.percentLoaded + "%" }}
                    </div>
                  </div>
                  <br />
                  <div class="text-center">
                    Você tambem pode arrastar e soltar
                    <br />o arquivo nesta caixa.
                  </div>
                </div>
              </div>
            </form>

            <div class="aggregate-list column">
              <div class="grid-4-g grid-7-m grid-12-s row">
                <input v-model="client.aggregate.search" type="text" class="input"
                  placeholder="Buscar cliente agregado (nome ou e-mail)" />
                &nbsp;
                <Button class="row align-center" layout="green-go" @click="searchAggregate(filteredClients[i])"
                  :loader="aggregateLoader">BUSCAR</Button>
              </div>
              <div class="no-aggregate" v-if="client.aggregate.list == null">
                <br />
                &nbsp;Não foi encontrado nenhum resultado.
              </div>
              <ul class="grid-12 column list">
                <li v-for="(ca, ia) of filteredClients[i].aggregate.list" :key="'clientagregado' + i + ia" class="row">
                  <div class="grid-1 id">
                    <b>{{ ca.id_usuario }}</b>
                  </div>
                  <div class="grid">{{ ca.nome }}</div>
                  <div class="grid">{{ ca.email }}</div>
                  <div class="grid hide-s">{{ ca.celular | phone }}</div>
                  <div class="controls row justify-end grid-1">
                    <div class="grid" :class="ca.status == 'ativo' ? 'green' : 'red'">
                      {{ ca.status }}
                    </div>
                    <div class="actions row">
                      <span v-if="ca.status == 'ativo'" title="Desativar cliente" class="del"
                        @click="delAggregate(filteredClients[i].aggregate.list[ia])">
                        Desativar
                      </span>
                      <span v-if="ca.status == 'inativo'" title="Ativar cliente" class="activate"
                        @click="activateAggregate(filteredClients[i].aggregate.list[ia])">
                        Ativar
                      </span>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <ClientesCliente :cliente="client.id" />
        </div>
      </li>
    </ul>
    <div v-else class="column align-center justify-center">
      <Loader />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Button from "@/components/Button.vue";
import Loader from "@/components/Loader.vue";
import ClientForm from "@/views/admin/components/ClientForm.vue";
import ClientesCliente from "@/views/admin/components/ClientesCliente.vue";
import Format from "@/utils/format";

export default {
  name: "Clients",
  components: { Button, Loader, ClientForm, ClientesCliente },
  data() {
    return {
      loader: true,
      search: "",
      file: { name: "", percentLoaded: 0 },
      files: [],
      allow: false,
      client: 0,
      showForm: false,
      aggregateLoader: false,
      filters: {
        engajamento: {
          data_inicio: null,
          data_fim: null,
        },
        cpf_cnpj: "",
        status: "",
      },
    };
  },
  beforeMount() {
    this.load()
  },
  methods: {
    ...mapActions("admin", [
      "LOAD_CLIENTS",
      "NEW_AGGREGATE",
      "IMPORT_AGGREGATE",
      "AGGREGATE_LIST",
      "DEL_AGGREGATE",
      "ACTIVATE_AGGREGATE",
    ]),
    async load() {
      this.showForm = false
      this.LOAD_CLIENTS().then(() => this.loader = false).catch(() => this.loader = false)
    },
    setID(client, index) {
      client.index = index;
      this.client = client;
      client.loader = true;
      document.getElementById("attach" + client.id).value = "";
      document.getElementById("attach" + client.id).click();
    },
    toggleClient(client) {
      client.show = !client.show;
      client.aggregate = client.aggregate || {
        nome: "",
        celular: "",
        email: "",
        show: false,
        /* document: window.document, */
        search: "",
        list: [],
      };

      this.$forceUpdate();
    },
    showAggregate(client) {
      client.aggregate.show = !client.aggregate.show;
      this.$forceUpdate();
    },
    newAggregate(client) {
      client.aggregate.celular = Format.clear(client.aggregate.celular);
      this.NEW_AGGREGATE({ id_cliente: client.id, ...client.aggregate }).then((r) => {
        if (r.status == 200 || r.status == 201) {
          client.aggregate = {
            ...client.aggregate,
            nome: "",
            celular: "",
            email: "",
            show: true,
          };
          this.$forceUpdate();
        }
      });
    },
    delAggregate(client) {
      this.DEL_AGGREGATE(client.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          client.status = "inativo";
          this.$forceUpdate();
        }
      });
    },
    activateAggregate(client) {
      this.ACTIVATE_AGGREGATE(client.id).then((r) => {
        if (r.status == 200 || r.status == 201) {
          client.status = "ativo";
          this.$forceUpdate();
        }
      });
    },
    searchAggregate(client) {
      this.aggregateLoader = true;
      let filter = client.aggregate.search.includes("@")
        ? { email: client.aggregate.search }
        : { nome: client.aggregate.search };
      this.AGGREGATE_LIST({ id_cliente: client.id, ...filter })
        .then((r) => {
          client.aggregate.list = r.data;
          this.$forceUpdate();
          this.aggregateLoader = false;
        })
        .catch(() => {
          client.aggregate.list = null;
          this.aggregateLoader = false;
        });
    },
    mask(client) {
      client.aggregate.celular = Format.phone(client.aggregate.celular);
      this.$forceUpdate();
    },
    drop(e) {
      let droppedFiles = e.dataTransfer.files;
      if (!droppedFiles) return;
      this.loadFile(droppedFiles);
    },
    loadFile(f) {
      //if (this.$refs.files.files.length) {
      this.allow = false;
      this.files = this.$refs.files.files;
      var file;
      if (f.target) file = f.target.files;
      if (f.dataTransfer) file = f.dataTransfer.files;
      if (f[0]) {
        file = f;
        this.files = f;
      }
      file = file[0];

      if (file) {
        let reader = new FileReader();
        reader.readAsBinaryString(file);
        reader.onprogress = (e) => {
          if (e.lengthComputable)
            this.file.percentLoaded = Math.round((e.loaded / e.total) * 100);
        };

        reader.onload = () => {
          if (file.type === "text/csv") {
            this.file.name = file.name;
            var formData = new FormData();
            formData.append("arquivo", file);

            this.IMPORT_AGGREGATE({ form: formData, id: this.client.id })
              .then(() => {
                this.client.loader = false;
                this.$forceUpdate();
              })
              .catch(() => {
                this.client.loader = false;
                this.$forceUpdate();
              });
          } else {
            this.SET_STATUS({
              color: "red",
              text: "TIPO DE ARQUIVO NÃO PERMITIDO",
            });
          }
        };
      }
      //}
    },
  },
  computed: {
    ...mapGetters("admin", ["clients"]),
    filteredClients() {
      if (this.search) {
        const search = this.search.toLowerCase();
        return this.clients.filter((client) => {
          const clientsSerialize = JSON.stringify(client).toLowerCase();
          return clientsSerialize.includes(search);
        });
      } else {
        return this.clients || [];
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/assets/scss/vars.scss" as *;

.clients {
  padding: 42px 35px;

  @media (max-width: $small) {
    padding: 7px;
  }

  .title {
    font-size: 24px;
    font-weight: bold;
    color: $purple;
    text-transform: uppercase;

    @media (max-width: $small) {
      margin-top: 38px;
      margin-bottom: 0px;
    }

    .new {
      background: white;
      border-radius: 14px;
      padding-top: 1px;
      margin-top: 20px;
      @include border;
    }

    .search {
      height: 45px;
      width: 100%;
      border-bottom: 1px solid $white-4;

      input {
        border: none;
        font-weight: bold;
        background: none;
        width: 92%;
        box-shadow: none;

        @media (max-width: $small) {
          width: 92%;
        }

        &:focus {
          background: none !important;
          box-shadow: 0 0 0 0;
          border: 0 none;
          outline: 0;
          color: $purple;
        }
      }

      &:after {
        content: "\f002";
        color: $white-4;
        position: absolute;
        margin-left: -25px;
        margin-top: 3px;
      }
    }

  }

  .status,
  .controls {
    font-weight: bold;
    font-size: 22px;

    &.green,
    .green {
      color: $green-1;
    }

    &.blue,
    .blue {
      color: $blue-3;
    }

    &.red,
    .red {
      color: $red-3;
    }
  }

  .list {
    margin-top: 25px;

    .label {
      font-weight: bold;
      color: $purple;
      padding: 14px 10px;
      font-size: 15px;

      @media (max-width: $small) {
        font-size: 12px;
      }
    }

    li {
      color: $gray-6;
      background: $white;
      border-radius: 8px;
      margin-bottom: 12px;
      box-shadow: $shadow;
      font-size: 14px;
      border: 2px solid $white;

      &:hover {
        border: 2px solid $client-2;
      }

      .line {
        padding: 19px 9px;
        cursor: pointer;
      }

      .id {
        color: $blue-5;
        font-size: 18px;
      }

      .status {
        div {
          font-weight: bold;
          border-radius: 50%;
          font-size: 14px;
          width: 22px;
          height: 20px;
          text-align: center;
          line-height: 22px;
        }

        span {
          color: $red-1;
          margin-left: 15px;
          font-weight: 300;
          cursor: pointer;

          &:hover {
            text-decoration: underline;
          }
        }
      }

      .aggregate {
        margin-top: 5px;
        padding: 20px 10px;

        h3 {
          font-size: 20px;
          background: rgba($purple, .8);
          color: white;
          padding: 3px 0;
          margin: 0 24px;
          text-align: center;
        }

        &-new-button {
          font-size: 12px;
          width: 125px;
          height: 32px;
          margin-top: 20px;
          margin-left: 30px;
        }

        &-import {
          background: #f1f1f1;
          padding: 20px;
          margin-top: 20px;
          border: 3px dashed #ccc;
          border-radius: 5px;

          p {
            line-height: 20px;
          }

          &-button {
            font-size: 12px;
            width: 200px;
            height: 32px;
            margin-left: 10px;
          }

          .filler {
            background: $green-8;
            height: 10px;
            padding-left: 10px;
            color: $gray-4;
            font-size: 12px;

            font-weight: bold;
          }

          .field {
            margin-top: 20px;
            height: 10px;
            background: #bbb;
            border: 1px solid #dbdbdb;
            border-radius: 10px;
            overflow: hidden;
            opacity: 1;
            width: 230px;
          }
        }

        &-new-form {
          padding: 7px;
          margin: 20px;

          input {
            @media (min-width: $small) {
              margin-right: 15px;
            }

            @media (max-width: $small) {
              margin-bottom: 20px;
            }
          }
        }

        &-list {
          margin: 20px;
          padding: 7px;

          .list {
            margin-top: 25px;

            li {
              padding: 10px;
              background: #f1f1f1;
              border: none;
              margin-bottom: 0px;

              .controls {
                .actions {
                  font-weight: 500;

                  .activate {
                    background: $green-2;
                  }

                  .del {
                    background: $red-1;
                  }

                  span {
                    width: 62px;
                    font-size: 13px;
                    text-align: center;
                    color: #fff;
                    padding: 3px 8px;
                    border-radius: 20px;

                    &:hover {
                      cursor: pointer;
                      box-shadow: $shadow;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .loader {
    margin-top: 8%;
  }
}
</style>
